import { ReactComponent as G2Badge } from '@/assets/g2-badge.svg'
import { ReactComponent as LogoHubspot } from '@/assets/logo-hubspot.svg'
import { ReactComponent as LogoAdobe } from '@/assets/logo-adobe.svg'
import { ReactComponent as LogoZapier } from '@/assets/logo-zapier.svg'
import { ReactComponent as LogoGrubhub } from '@/assets/logo-grubhub.svg'
import { ReactComponent as LogoEa } from '@/assets/logo-ea.svg'
import { ReactComponent as LogoCalendly } from '@/assets/logo-calendly.svg'

const companyLogos = [
  { Logo: LogoHubspot, alt: 'HubSpot' },
  { Logo: LogoAdobe, alt: 'Adobe', skinny: true },
  { Logo: LogoZapier, alt: 'Zapier' },
  { Logo: LogoGrubhub, alt: 'Grubhub' },
  { Logo: LogoEa, alt: 'EA', skinny: true },
  { Logo: LogoCalendly, alt: 'Calendly' },
]

export function SocialProofFooter() {
  return (
    <div className='fv:flex fv:flex-col fv:lg:flex-row fv:gap-3 fv:lg:gap-6 fv:items-center fv:w-full fv:max-w-screen-xl fv:mx-auto'>
      {/* G2 Rating Badge */}
      <div className='fv:flex fv:items-center fv:justify-center fv:w-full fv:lg:w-72 fv:shrink-0 fv:h-24 fv:lg:h-28 fv:bg-black/10 fv:rounded-3xl'>
        <G2Badge className='fv:h-11 fv:w-auto' aria-label='G2 - 5.0/5.0 - #1 rated - 6,500+ reviews' />
      </div>

      {/* Company Logos */}
      <div className='fv:flex fv:flex-col fv:lg:flex-row fv:items-start fv:lg:items-center fv:flex-1 fv:min-w-0 fv:py-5 fv:lg:py-0 fv:px-10 fv:lg:px-8 fv:h-auto fv:lg:h-28 fv:bg-black/10 fv:rounded-3xl fv:overflow-hidden fv:w-full'>
        <p className='fv:text-xs fv:text-off-white/45 fv:shrink-0 fv:mb-3 fv:lg:mb-0 fv:lg:mr-6 fv:lg:max-w-28'>
          Used at over 290K+ companies
        </p>
        <div className='fv:grid fv:grid-cols-3 fv:lg:flex fv:items-center fv:gap-2 fv:flex-1 fv:min-w-0 fv:w-full fv:lg:w-auto'>
          {companyLogos.map(({ Logo, alt, skinny }) => (
            <div
              key={alt}
              className={`fv:flex fv:items-center fv:justify-center fv:h-14 fv:lg:h-16 fv:min-w-0 fv:px-5 fv:bg-white/10 fv:rounded-lg fv:overflow-hidden ${skinny ? 'fv:flex-1' : 'fv:flex-2'}`}
            >
              <Logo aria-label={alt} className={skinny ? 'fv:h-8' : 'fv:h-6'} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
